import { render, staticRenderFns } from "./StarApp.vue?vue&type=template&id=414e8cac&scoped=true&"
import script from "./StarApp.vue?vue&type=script&lang=js&"
export * from "./StarApp.vue?vue&type=script&lang=js&"
import style0 from "./StarApp.vue?vue&type=style&index=0&id=414e8cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414e8cac",
  null
  
)

export default component.exports